import { dataAxios } from 'util/Api';

import {
  SHOW_ERROR_MESSAGE,
  SHOW_MESSAGE,
  FETCH_TRANSACTION_CHARGES_START,
  FETCH_TRANSACTION_CHARGES_ERROR,
  FETCH_TRANSACTION_CHARGES_SUCCESS,
  ADD_TRANSACTION_CHARGE_ERROR,
  ADD_TRANSACTION_CHARGE_START,
  ADD_TRANSACTION_CHARGE_SUCCESS,
  DELETE_TRANSACTION_CHARGE_START,
  DELETE_TRANSACTION_CHARGE_SUCCESS,
  DELETE_TRANSACTION_CHARGE_ERROR,
  UPDATE_TRANSACTION_CHARGE_START,
  UPDATE_TRANSACTION_CHARGE_SUCCESS,
  UPDATE_TRANSACTION_CHARGE_ERROR,
} from '../../constants/ActionTypes';
import { unicornAxios } from '../../util/Api';
import { GITLAB_PROJECT_IDS } from '../../constants/System';

export const getProcessingFeeTest = (requestData, callback) => () => {
  dataAxios.post('getProcessingFeeRPCTest', requestData).then((axiosResponse) => {
    const response = axiosResponse?.data;
    const data = response?.data;
    if (callback) {
      callback({
        success: true,
        message: response.message,
        data,
      });
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      if (callback) {
        callback({
          success: false,
          message: error.response.data.message,
          data: error.response.data || {},
        });
      }
    }
  });
};

export const getTransactionCharges = (params) => (dispatch) => {
  dispatch({ type: FETCH_TRANSACTION_CHARGES_START });
  dataAxios.get(`transactionChargeConfigs/${params ? `?${params}` : ''}`).then(({ data, headers }) => {
    dispatch({
      type: FETCH_TRANSACTION_CHARGES_SUCCESS,
      payload: data.data,
      meta: {
        page: Number(headers['content-range'].split('-')[0]),
        pageTotal: Number(headers['content-range'].split('/')[1]),
      },
    });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: FETCH_TRANSACTION_CHARGES_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

const redeployDataService = () => {
  unicornAxios.post('/gitlab-redeploy-project', {
    project_id: GITLAB_PROJECT_IDS.DATA_SERVICE,
  }).catch((error) => {
    console.error('Error: ', error.message);
  });
};

export const addTransactionCharge = (transactionCharge) => (dispatch) => {
  dispatch({ type: ADD_TRANSACTION_CHARGE_START });
  dataAxios.post('/transactionChargeConfigs', transactionCharge).then((axiosResponse) => {
    const response = axiosResponse?.data;
    if (response.data && response.data.name !== 'MongoError') {
      dispatch({ type: ADD_TRANSACTION_CHARGE_SUCCESS, payload: response.data });
      dispatch({ type: SHOW_MESSAGE, payload: `Added transaction charge: ${response.data.name}` });
      redeployDataService();
    } else {
      dispatch({ type: ADD_TRANSACTION_CHARGE_ERROR, payload: response.data.name });
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble adding this" });
      console.error('Error: ', response.data.name);
    }
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: ADD_TRANSACTION_CHARGE_ERROR, payload: error.response.data.message });
    }
    console.error('Error: ', error.message);
  });
};

export const deleteTransactionCharge = (transactionChargeId) => (dispatch) => {
  dispatch({ type: DELETE_TRANSACTION_CHARGE_START });
  dataAxios.delete(`/transactionChargeConfigs/${transactionChargeId}`).then((axiosResponse) => {
    const response = axiosResponse?.data;
    dispatch({ type: DELETE_TRANSACTION_CHARGE_SUCCESS, payload: transactionChargeId });
    dispatch({ type: SHOW_MESSAGE, payload: response.message });
    redeployDataService();
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble deleting this" });
    }
    dispatch({ type: DELETE_TRANSACTION_CHARGE_ERROR });
    console.error('Error: ', error.message);
  });
};

export const updateTransactionCharge = (transactionChargeId, values) => (dispatch) => {
  dispatch({ type: UPDATE_TRANSACTION_CHARGE_START });
  dataAxios.put(`/transactionChargeConfigs/${transactionChargeId}`, values).then((axiosResponse) => {
    const response = axiosResponse?.data;
    redeployDataService();
    dispatch({ type: UPDATE_TRANSACTION_CHARGE_SUCCESS, payload: response.data });
    dispatch({ type: SHOW_MESSAGE, payload: 'Succesfully updated transaction charge' });
  }).catch((error) => {
    if (error.response && error.response.data.message) {
      dispatch({ type: SHOW_ERROR_MESSAGE, payload: "Ops!, We're having trouble updating this" });
    }
    dispatch({ type: UPDATE_TRANSACTION_CHARGE_ERROR });
    console.error('Error: ', error.message);
  });
};
